import { onMounted, shallowRef, type Ref } from 'vue';
import { useInfiniteScroll } from '@vueuse/core';
import { findScrollViewport } from '@/libs/helpers/alphabet-index';

/**
 * Renders more rows of `list` as the passenger scrolls near its end. The list
 * scrolls inside a pane of the schedules page or the page content of a
 * standalone list: the scroll is watched on that ancestor, and an off-screen
 * pane loads nothing.
 */
export function useListLoadMore(
  list: Ref<HTMLElement | undefined>,
  loadMore: () => void,
  canLoadMore: () => boolean,
) {
  const viewport = shallowRef<HTMLElement | null>(null);
  onMounted(() => (viewport.value = findScrollViewport(list.value)));
  useInfiniteScroll(viewport, loadMore, { distance: 60, throttle: 100, canLoadMore });
}
